if (!customElements.get('tabbed-information')) {
  customElements.define('tabbed-information', class TabbedInformation extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        navLinks: this.querySelectorAll('[class^=tabbed-information__nav] li'),
        selectDropdownNav: this.querySelector('select[name=tabbed-section-selector]'),
        detailSections: this.querySelectorAll('[class^=tabbed-information__section]'),
      }
      
      for (let i = 0; i < this.elements.navLinks.length; i++) {
        this.elements.navLinks[i].addEventListener('click', this.setActiveSection.bind(this));
      }
      this.elements.selectDropdownNav.addEventListener('change', this.selectActiveSection.bind(this));
    }

    setActiveSection(e) {
      var target = e.target;
      var sectionName = target.getAttribute('ref');
      
      for (let i = 0; i < this.elements.navLinks.length; i++) {
        this.elements.navLinks[i].removeAttribute('active');
      }
      target.setAttribute('active', true);


      this.toggleSection(sectionName);
      this.elements.selectDropdownNav.value = sectionName;
    }

    selectActiveSection(e) {
      var sectionName = e.target.value;
      this.toggleSection(sectionName);

      for (let i = 0; i < this.elements.navLinks.length; i++) {
        const isMatch = this.elements.navLinks[i].getAttribute('ref') === sectionName;
        if (isMatch) {
          this.elements.navLinks[i].setAttribute('active', true);
        } else {
          this.elements.navLinks[i].removeAttribute('active');
        }
      }
      target.setAttribute('active', true);
    }

    toggleSection(sectionName) {
      for (let i = 0; i < this.elements.detailSections.length; i++) {
        const isMatch = this.elements.detailSections[i].getAttribute('ref') === sectionName;
        if (isMatch) {
          this.elements.detailSections[i].removeAttribute('hidden');
        } else {
          this.elements.detailSections[i].setAttribute('hidden', true);
        }
      }
    }
  });
}